// @owners { team: patients }
import { type ReduxStateShared } from '~shared/types';

// Keep these in sync with AdjustmentError in medication_management.rb
export const ADJUSTMENT_ERROR = {
  exceeded_allowed_days_supply: 'exceeded_allowed_days_supply',
  requires_progyny_approval: 'requires_progyny_approval',
  invalid_result: 'invalid_result',
};
export type AdjustmentError = keyof typeof ADJUSTMENT_ERROR;

// Keep these in sync with AdjustmentReason in medication_management.rb
export const ADJUSTMENT_REASON = {
  max_allowed_days_supply: 'max_allowed_days_supply',
  standard_medication_management_protocol: 'standard_medication_management_protocol',
  first_fill_supply_on_hand: 'first_fill_supply_on_hand',
  trigger_date: 'trigger_date',
  weekend_mail_order: 'weekend_mail_order',
};
export type AdjustmentReason = keyof typeof ADJUSTMENT_REASON;

export type MedicationManagementData = {
  adjustment_error?: AdjustmentError | null;
  adjustment_reasons?: AdjustmentReason[];
};

export type MedicationManagementDataByPrescriptionID = Record<string, MedicationManagementData | null | undefined>;

export const getProgynyWizardMedicationManagement = (
  state: ReduxStateShared,
): MedicationManagementDataByPrescriptionID => state.ui.progynyWizard?.medicationManagement;

export default getProgynyWizardMedicationManagement;
